import { render, staticRenderFns } from "./SkeletonGeneralInformationComponent.vue?vue&type=template&id=1e47d55e&scoped=true&"
import script from "./SkeletonGeneralInformationComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonGeneralInformationComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonGeneralInformationComponent.vue?vue&type=style&index=0&id=1e47d55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e47d55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
